
 <!-- 电费单设置 -->
<template>
  <div class="info">
    <div v-if="page==='head'" class="filter-container">
      <el-form
        ref="form"
        :model="info"
        label-width="125px"
      >
        <el-form-item :label="$t('text.tp')">
          <img-upload ref="imgUpload" v-model="info.logo" />
        </el-form-item>
        <el-form-item :label="$t('text.bt')">
          <el-input
            v-model="info.title"
          />
        </el-form-item>
        <el-form-item :label="$t('text.zhcxdh')">
          <el-input v-model="info.accountTel" />
        </el-form-item>
        <el-form-item :label="$t('text.zhcxgzsj')">
          <el-input v-model="info.accountTime" />
        </el-form-item>
        <el-form-item :label="$t('text.gzwxdh')">
          <el-input v-model="info.faultsTel" />
        </el-form-item>
        <el-form-item :label="$t('text.gzwxsj')">
          <el-input v-model="info.faultsTime" />
        </el-form-item>
        <el-form-item :label="$t('text.jjdh')">
          <el-input v-model="info.emergencyTel" />
        </el-form-item>
        <el-form-item :label="$t('text.jjgzsj')">
          <el-input v-model="info.emergencyTime" />
        </el-form-item>
        <el-form-item :label="$t('text.ybcxyx')">
          <el-input v-model="info.generalEmail" />
        </el-form-item>
        <el-form-item class="text-center">
          <el-button
            plain
            type="primary"
            @click="onSubmitHead"
          >{{ $t('button.bcsz') }}</el-button>
          <!-- <el-button>重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div v-if="page==='setbill'" class="filter-container">
      <el-form
        ref="form"
        :model="bill"
        label-width="120px"
      >
        <el-form-item :label="$t('text.yhxx1')">
          <el-input v-model="bill.userinfo1" />
        </el-form-item>
        <el-form-item :label="$t('text.yhxx2')">
          <el-input v-model="bill.userinfo2" />
        </el-form-item>
        <el-form-item :label="$t('text.yhdz1')">
          <el-input v-model="bill.useraddr1" />
        </el-form-item>
        <el-form-item :label="$t('text.yhdz2')">
          <el-input v-model="bill.useraddr2" />
        </el-form-item>
        <el-form-item :label="$t('text.fpdh')">
          <el-input v-model="bill.invoicenumpre" />
        </el-form-item>
        <el-form-item :label="$t('text.fpdcs')">
          <el-input v-model="bill.invoicenum" />
        </el-form-item>
        <el-form-item :label="$t('text.csdj')">
          <el-input v-model="bill.price" />
        </el-form-item>
        <el-form-item :label="$t('text.zdydj')">
          <el-input v-model="bill.customPrice" />
        </el-form-item>
        <el-form-item :label="$t('text.djyxj')">
          <!-- <el-input v-model="bill.priority" /> -->
          <el-select v-model="bill.priority" placeholder="请选择优先级.....">
            <el-option v-for="(item,index) in prioritys" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.zjfl')">
          <el-input v-model="bill.ratio" />
        </el-form-item>
        <el-form-item class="text-center">
          <el-button
            plain
            type="primary"
            @click="onSubmitBill"
          >{{ $t('button.bcsz') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="page==='pic'">
      <div class="pic">
        <img src="../../../assets/sl.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { SetBillHead, GetBillHead, GetBillSetting, BillSetting } from '@/api/Meter'
export default {
  components: {
    ImgUpload
  },
  data () {
    return {
      page: 'head',
      info: {},
      bill: {},
      prioritys: [{ label: '初始电价', value: '0' }, { label: '自定义电价', value: '1' }]
    }
  },
  mounted () {
    this.$bus.$on('head', () => {
      this.page = 'head'
    })
    this.$bus.$on('setbill', () => {
      this.page = 'setbill'
    })
    this.$bus.$on('pic', () => {
      this.page = 'pic'
    })
    this.getInfoList()
    this.getBillList()
  },
  beforeDestroy () {
    this.$bus.$off('head')
    this.$bus.$off('setbill')
    this.$bus.$off('pic')
  },
  methods: {
    // 获取电费单抬头信息
    getInfoList () {
      GetBillHead().then(res => {
        this.info = res.data || {}
      })
    },
    getBillList () {
      GetBillSetting({ id: this.$store.getters.station.id }).then(res => {
        this.bill = res.data || {}
        this.bill.orgid = this.$store.getters.station.id
      })
    },
    // 修改电费单信息
    onSubmitBill () {
      BillSetting(this.bill).then(() => {
        this.$msgSuccess(this.$t('notice.xgcg'))
        this.getBillList()
      })
    },
    // 修改电费单抬头信息
    onSubmitHead () {
      if (this.info.logo.indexOf('base64') === -1) {
        this.info.logo = null
      }
      SetBillHead(this.info).then(() => {
        this.$msgSuccess(this.$t('notice.xgcg'))
        this.getInfoList()
      })
    },
  }
}
</script>

<style lang='stylus' scoped>
.info
  height 100%
  .filter-container
    width 40%
    margin 0 auto
    margin-top 40px
.pic
  text-align center
</style>
